// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-icon{transition:all .3s cubic-bezier(.25,.8,.5,1),visibility 0s!important}.v-icon--is-component{font-size:18px;height:18px;width:auto}", ""]);
// Exports
module.exports = exports;
